var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Dependencies } from "~/core/decorator";
import { ReminderMessageService } from "~/services/common-service/reminder-message.service";
import { PageService } from "~/utils/page.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import DataBox from "~/components/common/data-box.vue";
import { namespace } from "vuex-class";
import { Prop, Watch, Emit, Component } from "vue-property-decorator";
import { ReminderMessageType } from "~/utils/reminder.service";
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
var workspaceModule = namespace("workspace");
var MessageBox = /** @class */ (function (_super) {
    __extends(MessageBox, _super);
    function MessageBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messageDataSet = [];
        _this.selectionList = [];
        _this.queryMsgModel = {
            readStatus: ""
        };
        return _this;
    }
    /**
     * 初始化
     */
    MessageBox.prototype.mounted = function () {
        this.refreshData();
    };
    MessageBox.prototype.emitUpdateMsgCount = function () { return; };
    MessageBox.prototype.emitViewDetail = function (data) {
        this.setReadState(data.id);
    };
    MessageBox.prototype.onVisibleChange = function (value) {
        if (value) {
            this.refreshData();
        }
    };
    Object.defineProperty(MessageBox.prototype, "messageType", {
        get: function () {
            return !this.isLegalMessage ? '' : ReminderMessageType.LegalTaskMessage;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取行样式
     */
    MessageBox.prototype.getRowClass = function (scope, index) {
        return scope.row.state.toLowerCase();
    };
    /**
     * 刷新数据
     */
    MessageBox.prototype.refreshData = function () {
        var _this = this;
        this.reminderMessageService
            .getReminderMessages(this.queryMsgModel.readStatus, this.messageType, this.pageService)
            .subscribe(function (data) {
            _this.messageDataSet = data;
            _this.operationHandler();
        });
    };
    MessageBox.prototype.operationHandler = function () {
        if (!this.isLegalMessage) {
            this.updateUnReadCount();
            this.updateMessageBoxVisible(true);
        }
        else {
            this.updateLegalUnReadCount();
            this.updateLegalMessageBoxVisible(true);
        }
    };
    /**
     * 查询类型变更
     */
    MessageBox.prototype.onStateChange = function () {
        this.pageService.reset();
        this.refreshData();
    };
    /**
     * 批量删除消息
     */
    MessageBox.prototype.deleteMessages = function () {
        if (this.selectionList.length === 0) {
            this.$message('请选择要删除的消息');
        }
        var messageIdList = this.selectionList.map(function (x) { return x.id; });
        this.deleteMessageRecord.apply(this, messageIdList);
    };
    /**
     * 从服务器删除消息数据
     */
    MessageBox.prototype.deleteMessageRecord = function () {
        var _this = this;
        var ids = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ids[_i] = arguments[_i];
        }
        this.reminderMessageService.batchDelete(ids).subscribe(function () {
            _this.pageService.reset();
            _this.refreshData();
            _this.emitUpdateMsgCount();
            if (!_this.isLegalMessage)
                _this.updateUnReadCount();
            else
                _this.updateLegalUnReadCount();
        });
    };
    /**
     * 设置消息为已读状态
     */
    MessageBox.prototype.setReadState = function (id) {
        var _this = this;
        this.reminderMessageService.setMessageRead(id).subscribe(function () {
            if (_this.messageDataSet.length === 1) {
                _this.pageService.reset();
            }
            _this.refreshData();
            _this.emitUpdateMsgCount();
            _this.operationHandler();
        });
    };
    MessageBox.prototype.openExecutionPage = function (id) {
        var _this = this;
        if (!id)
            return;
        this.caseOperatorPageService.getCaseInfoRecordIdById(id).subscribe(function (data) {
            if (!data)
                return _this.$message.error('案件归属非本人或案件状态非在催无法查看案件详情！');
            _this.$router.openCaseDetail(id, {
                menuChannel: MENU_CHANNEL.Tel_personal
            });
            _this.updateMessageBoxVisible(false);
            _this.updatedIsMessageShow(true);
        });
    };
    __decorate([
        Dependencies(ReminderMessageService)
    ], MessageBox.prototype, "reminderMessageService", void 0);
    __decorate([
        Dependencies(PageService)
    ], MessageBox.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], MessageBox.prototype, "caseOperatorPageService", void 0);
    __decorate([
        workspaceModule.Mutation
    ], MessageBox.prototype, "updateMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.Mutation
    ], MessageBox.prototype, "updateLegalMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.Action
    ], MessageBox.prototype, "updateUnReadCount", void 0);
    __decorate([
        workspaceModule.Action
    ], MessageBox.prototype, "updateLegalUnReadCount", void 0);
    __decorate([
        workspaceModule.Mutation
    ], MessageBox.prototype, "updatedIsMessageShow", void 0);
    __decorate([
        Prop()
    ], MessageBox.prototype, "visible", void 0);
    __decorate([
        Prop()
    ], MessageBox.prototype, "isLegalMessage", void 0);
    __decorate([
        Emit("update-msg-count")
    ], MessageBox.prototype, "emitUpdateMsgCount", null);
    __decorate([
        Emit("view-detail")
    ], MessageBox.prototype, "emitViewDetail", null);
    __decorate([
        Watch("visible")
    ], MessageBox.prototype, "onVisibleChange", null);
    MessageBox = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], MessageBox);
    return MessageBox;
}(Vue));
export default MessageBox;
